import type { BriefQuestion } from '@dyspatch/core';

/**
 * The forks nobody has settled yet (docs/PLAN-QUESTIONS.md).
 *
 * `answer` alone decides it, not `acceptedAt`: a question Go accepted is closed
 * in the record but was never answered, and a job read after Go should still
 * show what was decided rather than an empty region. The gate line and the
 * region's own sort both ask this one function, so the count in the sentence
 * and the cards above the fold cannot disagree.
 */
export function openQuestions(questions: readonly BriefQuestion[]): BriefQuestion[] {
  return questions.filter((question) => !question.answer);
}

/** The sentence the plan gate adds when the planner left forks open. */
export function openQuestionsLine(count: number): string {
  if (count <= 0) return '';
  return (
    `${count} open question${count === 1 ? '' : 's'}, each already planned on an assumption. ` +
    `Go accepts ${count === 1 ? 'it' : 'them'} and records that you did.`
  );
}
